import UpdateQuestion from "pages/dashboard/shared/UpdateQuestion/UpdateQuestion";

const QuestionUpdate = () => {
  return <UpdateQuestion />;
};

export default QuestionUpdate;
